import {useEffect, useLayoutEffect, useRef} from "react";
import {getUrl, loadCss, setPrice} from "./lib";
import {identify, setRegister, setTrack, trackPaywall} from "./tracking";
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

export const usePaywall = ({landing = '', force = false, active} = {}) => {
  const
    {uid} = useParams(),
    [searchParams] = useSearchParams(),
    navigate = useNavigate(),
    {i18n} = useTranslation(),
    location = useLocation(),
    handledRef = useRef(false)

  // async use?
  if (uid && !window.localStorage.getItem('uid')) {
    window._uid = uid
    window.localStorage.setItem('uid', uid)
  }

  if (searchParams.get('email') && !window.localStorage.getItem('email')) {
    window._email = searchParams.get('email')
    window.localStorage.setItem('email', window._email)
  }

  useLayoutEffect(() => {
    loadCss(`/static/css/${landing ? landing + '/' : ''}Paywall.css`)
  }, [])

  const handlePaywall = (e = null) => {
    if (force)
      return

    if (e?.persisted) {
      // Страница вернулась из bfcache — сбрасываем
      handledRef.current = false
    }

    if (handledRef.current)
      return

    handledRef.current = true

    if (
      !window.localStorage.getItem('uid') && !uid ||
      window.localStorage.getItem('success')
    ) {
      window.localStorage.removeItem('success')
      navigate(getUrl('/'), {replace: true})
      return
    }

    if (!uid) {
      setTrack('paywall')
      trackPaywall()
      return
    }

    const utmData = {
      returning_user: true
    }

    if (searchParams.get('utm_source'))
      utmData['utm_source'] = searchParams.get('utm_source')

    if (searchParams.get('utm_campaign'))
      utmData['utm_campaign'] = searchParams.get('utm_campaign')

    if (searchParams.get('template'))
      utmData['template'] = searchParams.get('template')

    setRegister(utmData)

    utmData.lang = i18n.resolvedLanguage

    identify(
      uid,
      searchParams.get('email'),
      utmData,
    )

    setTrack('Email Session Started')
    setTrack('paywall')
    trackPaywall()
  }

  useEffect(() => {
    // Срабатывает при обычных переходах по SPA
    handlePaywall()
  }, [location.pathname])

  useEffect(() => {
    // Срабатывает при возврате из bfcache
    window.addEventListener('pageshow', handlePaywall)
    return () => {
      window.removeEventListener('pageshow', handlePaywall)
    }
  }, [])

  useEffect(() => {
    if (!active)
      return

    setTrack('pricing_option_selected', {plan: active.period})
    setPrice(active)
  }, [active])

  return {uid}
}